(function () {
  function getCampaignCollection() {
    var handle = sessionStorage.getItem('wc_campaign_collection');
    if (handle) {
      sessionStorage.removeItem('wc_campaign_collection');
      return handle;
    }
    return null;
  }

  function dismissPopup(popup, onKeyHandler) {
    popup.classList.remove('campaign-popup--visible');
    popup.setAttribute('aria-hidden', 'true');
    if (onKeyHandler) document.removeEventListener('keydown', onKeyHandler);
  }

  function showPopup(collectionHandle) {
    var popup = document.getElementById('campaign-popup');
    if (!popup) return;

    var ctaBtn = popup.querySelector('.campaign-popup__cta');
    if (ctaBtn) ctaBtn.href = '/collections/' + collectionHandle;

    popup.removeAttribute('aria-hidden');
    popup.classList.add('campaign-popup--visible');

    var closeBtn = popup.querySelector('.campaign-popup__close');
    var overlay = popup.querySelector('.campaign-popup__overlay');

    function onKey(e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        dismissPopup(popup, onKey);
      }
    }

    function onClose() {
      dismissPopup(popup, onKey);
    }

    if (closeBtn) closeBtn.addEventListener('click', onClose);
    if (overlay) overlay.addEventListener('click', onClose);
    document.addEventListener('keydown', onKey);

    if (closeBtn) closeBtn.focus();
  }

  function init() {
    var handle = getCampaignCollection();
    if (handle) showPopup(handle);
  }

  // pageshow fires on both normal load and bfcache restore (back/forward).
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) init();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
